import { Typography, ArrowForwardIosSharpIcon, Accordion, AccordionDetails, AccordionSummary } from 'external/material'
import { FC } from 'external/react'
import DotMenu from './DotMenu'


type BaseAccordionProps = {
  children: React.ReactNode
  title: string
}

export type MenuOptions = "delete" | "edit"

export type CanDoAction = {
  [key in MenuOptions]: boolean
}

type AccordionProps = BaseAccordionProps & (
  | { menuButton: true, handleDelete: (option: MenuOptions) => void, menuOptions: MenuOptions[], canDoActions: CanDoAction, shouldShowMenu: boolean }
  | { menuButton: false, handleDelete?: undefined, menuOptions?: undefined, canDoActions?: undefined, shouldShowMenu?: undefined }
)


export const ItemAccordion: FC<AccordionProps> = ({ children, title, menuButton, handleDelete, menuOptions, canDoActions, shouldShowMenu }) => {
  return (
    <Accordion sx={{ '&::before': { display: 'none' } }} disableGutters={true} elevation={0}>
      <AccordionSummary sx={{backgroundColor: 'rgba(165, 211, 243, 0.5)', flexDirection: 'row-reverse'}} expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: 16, transform: 'rotate(270deg)' }} />}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {(menuButton && shouldShowMenu) && 
            <div
              style={{
                position: 'absolute',
                right: 0,
                padding: '8px 5px',
                cursor: 'pointer',
                marginRight: '4px',
              }}
            >
              <DotMenu 
                actions={{
                  delete: handleDelete,
                  edit: () => ''
                }}
                canDoActions={canDoActions}
                options={menuOptions ?? []}
              />
            </div>
          }
          <Typography component='span' sx={{ fontWeight: 'bold', color: 'rgba(0,0,30,1)', marginLeft: '10px' }}>{title}</Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails sx={{padding: 0}}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}